import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Message } from "primereact/message";

import { getRutasActivas } from "../Integracion";

/**
 * Diálogo para marcar la cotización como combinable: muestra un selector
 * con filtro de todas las rutas activas.
 */
const DialogCombinable = ({ visible, onHide, onConfirmar, idRutaInicial = null }) => {
    const [rutas, setRutas] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [error, setError] = useState(null);
    const [idRuta, setIdRuta] = useState(idRutaInicial);
    const [guardando, setGuardando] = useState(false);

    // Las rutas se cargan al abrir para tener siempre el catálogo actualizado.
    useEffect(() => {
        if (!visible) return;
        setIdRuta(idRutaInicial);
        setError(null);
        setCargando(true);
        getRutasActivas()
            .then((res) => setRutas(Array.isArray(res?.data) ? res.data : []))
            .catch(() => setError("No se pudieron cargar las rutas activas."))
            .finally(() => setCargando(false));
    }, [visible, idRutaInicial]);

    const handleConfirmar = async () => {
        setGuardando(true);
        try {
            await onConfirmar(rutas.find((r) => r.id === idRuta));
        } finally {
            setGuardando(false);
        }
    };

    const itemTemplate = (ruta) => (
        <div className="flex flex-column">
            <span>{ruta.nombre}</span>
            {ruta.cliente && <small className="text-color-secondary">{ruta.cliente}</small>}
        </div>
    );

    const footer = (
        <div>
            <Button label="Cancelar" className="p-button-text" onClick={onHide} disabled={guardando} />
            <Button
                label="Marcar como combinable"
                icon="pi pi-link"
                severity="info"
                onClick={handleConfirmar}
                disabled={!idRuta}
                loading={guardando}
            />
        </div>
    );

    return (
        <Dialog
            header="Marcar cotización como combinable"
            visible={visible}
            onHide={onHide}
            footer={footer}
            style={{ width: "32rem" }}
            breakpoints={{ "640px": "95vw" }}
        >
            <p className="mt-0">Selecciona la ruta activa con la que se puede combinar esta cotización.</p>
            {error && <Message severity="error" text={error} className="w-full mb-2" />}
            <Dropdown
                value={idRuta}
                options={rutas}
                optionLabel="nombre"
                optionValue="id"
                itemTemplate={itemTemplate}
                onChange={(e) => setIdRuta(e.value)}
                filter
                filterBy="nombre,cliente"
                placeholder={cargando ? "Cargando rutas..." : "Selecciona una ruta..."}
                disabled={cargando}
                className="w-full"
                emptyMessage="Sin rutas activas"
                emptyFilterMessage="No se encontraron coincidencias"
                virtualScrollerOptions={rutas.length > 100 ? { itemSize: 48 } : undefined}
            />
        </Dialog>
    );
};

export default DialogCombinable;
